import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'organizations',
    pathMatch: 'full',
    loadChildren: () =>
      import('./organisations/organisations-list.module').then((m) => m.OrganisationsListModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'organizations/:id',
    loadChildren: () =>
      import('./organisations/organisation-detail/organisation-detail.module').then(
        (m) => m.OrganisationDetailModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'people',
    pathMatch: 'full',
    loadChildren: () =>
      import('./people/people-list.module').then((m) => m.PeopleListModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'people/:org_person_id',
    loadChildren: () =>
      import('./people/person-detail/person-detail.module').then((m) => m.PersonDetailModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'assessments',
    pathMatch: 'full',
    loadChildren: () =>
      import('./assessments/assessments-list.module').then((m) => m.AssessmentsListModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'assessments/:org_person_assessment_id/report',
    loadChildren: () =>
      import('./assessment-report/assessment-report.module').then(
        (m) => m.AdminAssessmentReportModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'no-access',
    loadChildren: () => import('./no-access/no-access.module').then((m) => m.NoAccessModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
